'use strict';

// define 'forms' namespace
if (!('forms' in window)) window['forms'] = {};

/***********************
 * Global onload event *
 ***********************/

$(function () {
    forms.handleTaxonomySelects();

    $('.form-ajax-submit').on('click', function (e) {
        e.preventDefault();

        forms.disableSubmit(e);
        forms.ajaxSubmit(e);
    });

    $('#download-form input[name=email]').on('click', function (e) {
        let form = $(e.target).closest('form');

        forms.setDownloadFormValues(form);
    });

    $('body').on('input', 'form[name=search_form] input[name=query]', function (e) {
        e.preventDefault();

        let termLength = $(this).val().length;

        if (termLength >= 2 && termLength <= 50) {
            // enable "search" magnifying glass when input is valid to start a search
            $('[data-js=search-form-submit]').removeClass('btn-disabled');
        } else {
            // disable "search" magnifying glass when input is not valid to start a search
            $('[data-js=search-form-submit]').addClass('btn-disabled');
        }
    });

    setTimeout(function () {
        // Add name attribute to the form in debugbar so we can filter it out.
        $('.phpdebugbar-openhandler-actions form').attr('name', 'phpdebugbar_form');

        // All other forms (because newsletter and search can be on the same page as other forms)
        let inputs = $('body form')
            .not('[name=\'newsletter_footer_form\'], [name=\'search_form\'],  [name=\'phpdebugbar_form\'], [name=\'product_review_form\'], .cookie__customize')
            .find(':input[required]');

        $.each(inputs, function (index, input) {
            $(input).bind('input', function () {
                let values = [];
                $.each(inputs, function (nestedIndex, nestedInput) {
                    values.push(nestedInput.value);
                });

                // If there is no empty values, enable the button
                if (!values.includes('')) {
                    forms.enableSubmit();
                } else {
                    forms.disableSubmitNoSpinner();
                }
            });
        });

    }, 300);

});

/*********************************
 * Methods (in "forms" namespace) *
 *********************************/

forms.ajaxSubmit = function (e) {
    let formButton = $(e.target);
    let form = formButton.closest('form');
    let formHtmlElement = form[0];
    let formRow = form.find('#form-row');
    let confirmationRow = form.find('#confirmation-row');
    let formErrorSpan = form.find('span[data-failure]');
    let failureMessage = formErrorSpan.data('failure');

    // allows additional actions in form specific js by listening to this trigger
    form.trigger('form.ajaxSubmit');

    // clear potential previously set validation errors
    forms.clearValidationErrors(form);

    // Show the spinning loader
    $('#envelope-icon').addClass('d-none');
    $('#spinning-loader').removeClass('d-none');

    // Get the formData for this form. (Doing this in the AJAX call results in an Illegal Invocation error)
    let formData = new FormData(formHtmlElement);

    // Submit the form through Statamic using AJAX
    $.ajax({
        url: formHtmlElement.action,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
    })
      .done(response => {
          if (response.success) {
              confirmationRow.removeClass('d-none');
              formRow.addClass('d-none');
              formButton.addClass('d-none');

              $('html, body').stop(true,true).animate({
                  scrollTop: (confirmationRow.offset().top - 70)
              }, 500, 'linear');

              forms.enableSubmit(e);
          }
      })
      .fail(response => {
          form.trigger('form.fail');
          if (response.status === 404) {
              console.log(response.responseJSON.message);

              formErrorSpan.html(failureMessage);
              formErrorSpan.show();
          } else {
              $.each(response.responseJSON.error, function (formFieldName, validationErrorText) {
                  let formField = form.find(`[name=${formFieldName}]`);
                  let formFieldValidationSpan = form.find(`span.${formFieldName}`);

                  formFieldValidationSpan.html(validationErrorText);
                  formFieldValidationSpan.show();
                  formField.addClass('is-invalid');
              });

              forms.enableSubmit(e);
          }
      });
};

forms.removeCollapse = function () {
    if ($('.split-blocks .collapse, .split-blocks .collapse-link').is(':visible')) {
        $('.split-blocks .collapse, .split-blocks .collapse-link').remove();
    }

    if ($('#newsletter_form').is(':visible')) {
        $('[rel="gaUrl"]').attr('href', 'https://' + document.location.host + '/en/newsletter-result');
    }
};

forms.enableSubmit = function (e) {
    // remove spinning loader and enable the button
    $('#spinning-loader').addClass('d-none');
    $('#envelope-icon').removeClass('d-none');

    // if e is undefined find the closest submit button to the spinning-loader.
    if (e === undefined) {
        let button = $('.form-ajax-submit');
        button.prop('disabled', false);
        button.removeClass('btn-disabled');
    } else {
        $(e.target).prop('disabled', false);
    }
};

forms.disableSubmit = function (e) {
    // show spinning loader and disable the button
    $('#envelope-icon').addClass('d-none');
    $('#spinning-loader').removeClass('d-none');
    $(e.target).prop('disabled', true);
};

forms.disableSubmitNoSpinner = function (e) {
    // if e is undefined find the closes submit button to the spinning-loader.
    if (e === undefined) {
        let button = $('.form-ajax-submit');
        button.prop('disabled', true);
        button.addClass('btn-disabled');
    } else {
        $(e.target).prop('disabled', true);
        $(e.target).addClass('btn-disabled');
    }
};

forms.clearValidationErrors = function (form) {
    form.find('.form-group').each(function (index, formGroup) {
        let formField = $(formGroup).find('.form-control');
        formField.removeClass('is-invalid');

        let formInvalidFeedbackSpans = $(formGroup).find('.invalid-feedback');
        formInvalidFeedbackSpans.hide();
        formInvalidFeedbackSpans.empty();
    });
};

forms.handleTaxonomySelects = function () {
    // Only try this if the composed data exists
    if ($('#composed-view-data').length !== 0) {
        let composedDataElement = $('#composed-view-data');

        // Add name attribute to the form in debugbar so we can filter it out.
        $('.phpdebugbar-openhandler-actions form').attr('name', 'phpdebugbar_form');
        let forms = $('body form').not('[name=\'search_form\'],  [name=\'phpdebugbar_form\']');

        // And the country and language data is not undefined.
        if (typeof composedDataElement.data('countries') !== 'undefined' && typeof composedDataElement.data('languages') !== 'undefined') {
            $(forms).each(function (index, form) {
                let countryInput = $(form).find('select[name="country"]').first();
                let languageInput = $(form).find('select[name="language_select"]').first();
                let countries = composedDataElement.data('countries');
                let languages = composedDataElement.data('languages');

                // Select and disable the 'Make your choice' option (selected will be overridden by the current country)
                $(countryInput).find('option[value="choose-option"]').attr('selected', true).attr('disabled', true);

                $.each(countries, function (slug, title) {
                    let option = document.createElement('option');
                    if (slug === detected_country_id) {
                        option.setAttribute('selected', true);
                    }
                    option.value = slug;
                    option.text = title;
                    countryInput.append(option);
                });

                // If at this point there is no selected option in the countryInput, select the first one, and make disabled.
                if (! $(countryInput).val()) {
                    $(countryInput).selectedIndex = 0;
                    $(countryInput).find(":selected").prop('disabled', true)
                }

                // Select and disable the 'Make your choice' option (selected will be overridden by the current language)
                $(languageInput).find('option[value="choose-option"]').attr('selected', true).attr('disabled', true);

                let languageSelected = false;
                $.each(languages, function (locale, languageName) {
                    let option = document.createElement('option');
                    if (locale.includes(detected_language) && !languageSelected) {
                        option.setAttribute('selected', true);
                        languageSelected = true;
                    }
                    option.value = locale;
                    option.text = languageName;

                    languageInput.append(option);
                });

                // If at this point there is no selected option in the languageInput, select the first one, and make disabled.
                if (! $(languageInput).val()) {
                    $(languageInput).selectedIndex = 0;
                    $(languageInput).find(":selected").prop('disabled', true)
                }
            });
        }
    }

    forms.setDownloadFormValues = function (form) {
        // Copy the hidden values to the statamic form inputs.
        let downloadInformation = $('#download-information');
        let downloadContainer = downloadInformation.data('js-download-container');
        let downloadIdentifier = downloadInformation.data('js-download-identifier');
        let downloadTitle = downloadInformation.data('js-download-title');
        let downloadSlug = downloadInformation.data('js-download-slug');
        let downloadCategories = downloadInformation.data('js-download-categories');

        let statamicContainerInput = form.find('input[name=download_container');
        let statamicIdentifierInput = form.find('input[name=download_identifier');
        let statamicTitleInput = form.find('input[name=download_title]');
        let statamicSlugInput = form.find('input[name=download_slug]');
        let statamicCategoriesInput = form.find('input[name=download_categories]');

        statamicContainerInput.attr('value', downloadContainer);
        statamicIdentifierInput.attr('value', downloadIdentifier);
        statamicTitleInput.attr('value', downloadTitle);
        statamicSlugInput.attr('value', downloadSlug);
        statamicCategoriesInput.attr('value', downloadCategories);
    }
};
